import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import Map from "../Main/Map/Map.js";

export default function Contacts() {
  return (
    <section className="contacts">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Контакты
      </h1>

      <table className="contacts__table">
        <tbody>
          <tr className="contacts__line">
            <th className="contacts__caption" colSpan={2}>
              Контактные телефоны
            </th>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Заместитель директора по научной работе профессор, д.м.н.
              <br></br>Зильберберг Наталья Владимировна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189570" className="contacts__table-tel">
                +7 (343) 218-95-70
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Зав. клиникой, к.м.н. <br></br>Гришаева Елена Владимировна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432183370" className="contacts__table-tel">
                +7 (343) 218-33-70
              </a>
            </td>
          </tr>
          {/* <tr className="contacts__line">
            <td className="contacts__cell">
              Ученый секретарь, д.м.н., доцент <br></br>Куклин Игорь
              Александрович
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432188954" className="contacts__table-tel">
                +7 (343) 218-89-54
              </a>
            </td>
          </tr> */}
          <tr className="contacts__line">
            <td className="contacts__cell">
              Заведующий научным клиническим отделом дерматологии Заслуженный
              врач России, профессор, д.м.н. <br></br>Кохан Муза Михайловна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189560" className="contacts__table-tel">
                +7 (343) 218-95-60
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Заведующий научно-образовательным отделом, профессор, д.м.н.
              <br></br>Сырнева Татьяна Анатольевна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432187717" className="contacts__table-tel">
                +7 (343) 218-33-52
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Заведующий научным экспериментально-лабораторным отделом доцент,
              д.м.н. <br></br>Евстигнеева Наталья Петровна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189569" className="contacts__table-tel">
                +7 (343) 218-95-69
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Заведующий научным клиническим отделом сифилидологии и инфекций,
              передаваемых половым путем доцент, к.м.н. <br></br>Левчик Надежда
              Константиновна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432187899" className="contacts__table-tel">
                +7 (343) 218-78-99
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Ведущий научный сотрудник научного клинического отдела
              дерматологии, д.м.н., доцент <br></br>Филимонкова Нина Николаевна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432188725" className="contacts__table-tel">
                +7 (343) 218-87-25
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Ведущий научный сотрудник научного клинического отдела
              дерматологии, зав. отделением хронических дерматозов для взрослых,
              д.м.н.
              <br></br>Кениксфест Юлия Владимировна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189561" className="contacts__table-tel">
                +7 (343) 218-95-61
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Ведущий научный сотрудник научного клинического отдела
              сифилидологии и инфекций, передаваемых половым путем, д.м.н.,
              доцент <br></br>Грекова Юлия Николаевна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432181799" className="contacts__table-tel">
                +7 (343) 218-17-99
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Зав. отделением дерматовенерологии - круглосуточный стационар,
              к.м.н. <br></br>Кащеева Яна Викторовна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432188954" className="contacts__table-tel">
                +7 (343) 218-89-54
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Зав. отделением дерматовенерологии - дневной стационар, к.м.н.
              <br></br>Летаева Ольга Владимировна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432183352" className="contacts__table-tel">
                +7 (343) 218-33-52
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Зав. отделением хронических дерматозов для детей <br></br>Насырова
              Лариса Юрьевна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432183374" className="contacts__table-tel">
                +7 (343) 218-33-74
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Зав. консультативно-диагностическим отделением к.м.н. <br></br>
              Скидан Николай Иванович
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189568<" className="contacts__table-tel">
                +7 (343) 218-95-68
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Начальник отдела кадров <br></br>Петрунина Людмила Степановна
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189585<" className="contacts__table-tel">
                +7 (343) 218-95-85
              </a>
            </td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell">
              Запись к специалистам в консультативно-диагностическое отделение
            </td>
            <td className="contacts__cell contacts__tel">
              <a href="tel:+73432189586" className="contacts__table-tel">
                +7 (343) 218-95-86
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <Map />
    </section>
  );
}
